export default __webpack_public_path__ + "static/project-slide-4-4032-2268-f3978474a97ed70e09718426bf0d9293.webp";